(() => {
  const initialize = root => {
    if (root.dataset.filtroReady === "true") return;
    root.dataset.filtroReady = "true";
    const form = root.querySelector(".sfp-form");
    const variantInputs = [...root.querySelectorAll("[data-filtro-variant]")];
    const updateVariant = (input, updateUrl = false) => {
      if (!input) return;
      const available = input.dataset.available === "true";
      variantInputs.forEach(item => item.closest(".sfp-pack").classList.toggle("is-selected", item === input));
      root.querySelectorAll("[data-filtro-price]").forEach(item => { item.textContent = input.dataset.price; });
      root.querySelectorAll("[data-filtro-pack-label]").forEach(item => { item.textContent = input.dataset.pack; });
      root.querySelectorAll("[data-filtro-buy]").forEach(button => {
        button.disabled = !available;
        const label = button.querySelector("[data-buy-label]");
        if (label) label.textContent = available ? root.dataset.availableLabel : root.dataset.unavailableLabel;
      });
      const unavailableText = root.querySelector("[data-filtro-unavailable]");
      if (unavailableText) unavailableText.hidden = available;
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", input.value);
        window.history.replaceState(window.history.state, "", url);
      }
    };
    variantInputs.forEach(input => input.addEventListener("change", () => updateVariant(input, true)));
    updateVariant(variantInputs.find(input => input.checked));
    const initializeMotion = container => {
      container.querySelectorAll("[data-filtro-motion]").forEach(motion => {
        const image = motion.querySelector("img[data-motion-src]");
        const button = motion.querySelector("[data-motion-toggle]");
        if (!image || !button) return;
        let playing = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        const updateMotion = () => {
          image.src = playing ? image.dataset.motionSrc : image.dataset.stillSrc;
          button.textContent = playing ? button.dataset.pauseLabel : button.dataset.playLabel;
          button.setAttribute("aria-pressed", String(playing));
        };
        button.addEventListener("click", () => { playing = !playing; updateMotion(); });
        updateMotion();
      });
    };
    initializeMotion(root);
    const microreviews = root.querySelector("[data-filtro-microreviews]");
    if (microreviews) {
      const reviews = [...microreviews.querySelectorAll("[data-microreview]")];
      let currentReview = 0;
      const moveReview = step => {
        currentReview = (currentReview + step + reviews.length) % reviews.length;
        reviews.forEach((review, index) => { review.hidden = index !== currentReview; });
      };
      microreviews.querySelector("[data-microreview-prev]")?.addEventListener("click", () => moveReview(-1));
      microreviews.querySelector("[data-microreview-next]")?.addEventListener("click", () => moveReview(1));
    }
    const gallery = root.querySelector("[data-filtro-gallery]");
    if (gallery) {
      const slides = [...gallery.querySelectorAll("[data-gallery-slide]")];
      const thumbnails = [...gallery.querySelectorAll("[data-gallery-index]")];
      const stage = gallery.querySelector("[data-gallery-stage]");
      const counter = gallery.querySelector("[data-gallery-count]");
      const dialog = gallery.querySelector("[data-gallery-dialog]");
      const expanded = gallery.querySelector("[data-gallery-expanded]");
      let current = 0;
      let pointerStart = null;
      const selectSlide = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.hidden = i !== current;
          slide.classList.toggle("is-active", i === current);
        });
        thumbnails.forEach((button, i) => button.setAttribute("aria-pressed", String(i === current)));
        if (counter) counter.textContent = `${current + 1} / ${slides.length}`;
      };
      thumbnails.forEach(button => button.addEventListener("click", () => selectSlide(Number(button.dataset.galleryIndex))));
      gallery.querySelector("[data-gallery-prev]")?.addEventListener("click", () => selectSlide(current - 1));
      gallery.querySelector("[data-gallery-next]")?.addEventListener("click", () => selectSlide(current + 1));
      stage?.addEventListener("keydown", event => {
        if (event.key === "ArrowRight") { event.preventDefault(); selectSlide(current + 1); }
        if (event.key === "ArrowLeft") { event.preventDefault(); selectSlide(current - 1); }
      });
      stage?.addEventListener("pointerdown", event => {
        if (event.target.closest("button")) return;
        pointerStart = { x: event.clientX, y: event.clientY };
      }, { passive: true });
      stage?.addEventListener("pointerup", event => {
        if (!pointerStart) return;
        const distance = event.clientX - pointerStart.x;
        const vertical = event.clientY - pointerStart.y;
        pointerStart = null;
        if (Math.abs(distance) > 45 && Math.abs(distance) > Math.abs(vertical) * 1.4) selectSlide(current + (distance < 0 ? 1 : -1));
      }, { passive: true });
      stage?.addEventListener("pointercancel", () => { pointerStart = null; });
      gallery.querySelector("[data-gallery-zoom]")?.addEventListener("click", () => {
        if (!dialog || !expanded) return;
        const figure = slides[current].cloneNode(true);
        figure.hidden = false;
        figure.removeAttribute("data-gallery-slide");
        figure.querySelectorAll("img").forEach(image => { image.loading = "eager"; });
        expanded.replaceChildren(figure);
        initializeMotion(expanded);
        dialog.showModal();
      });
      gallery.querySelector("[data-gallery-close]")?.addEventListener("click", () => dialog?.close());
      dialog?.addEventListener("click", event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
    }
    root.querySelectorAll("[data-filtro-compare]").forEach(compare => {
      const slider = compare.querySelector("[data-compare-range]");
      slider?.addEventListener("input", () => compare.style.setProperty("--compare", `${slider.value}%`));
    });
    const cartDialog = root.querySelector("[data-filtro-cart]");
    if (cartDialog) {
      const cartUrl = cartDialog.dataset.cartUrl;
      const cartItems = cartDialog.querySelector("[data-cart-items]");
      const cartLoading = cartDialog.querySelector("[data-cart-loading]");
      const cartError = cartDialog.querySelector("[data-cart-error]");
      let cartOpener = null;
      let updatingCart = false;
      let addingToCart = false;
      const make = (tag, className, text) => {
        const node = document.createElement(tag);
        if (className) node.className = className;
        if (text !== undefined) node.textContent = text;
        return node;
      };
      const showCartError = error => {
        cartError.querySelector("[data-cart-error-message]").textContent = error?.message || cartDialog.dataset.errorLabel;
        cartError.hidden = false;
      };
      const requestCart = async (path, options = {}) => {
        const response = await fetch(path, { ...options, headers: { Accept: "application/json", ...options.headers } });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || cartDialog.dataset.errorLabel);
        return data;
      };
      const renderCart = cart => {
        const money = cents => new Intl.NumberFormat(document.documentElement.lang || "nl", { style: "currency", currency: cart.currency || "EUR" }).format(cents / 100);
        cartItems.replaceChildren();
        cart.items.forEach(item => {
          const article = make("article", "sfp-cart-item");
          article.dataset.lineKey = item.key;
          if (item.image) {
            const image = make("img");
            image.src = item.image;
            image.alt = item.product_title;
            image.width = 90;
            image.height = 90;
            image.loading = "lazy";
            article.append(image);
          }
          const body = make("div", "sfp-cart-item-body");
          const title = make("a", "sfp-cart-item-title", item.product_title);
          title.href = item.url;
          body.append(title);
          if (item.variant_title && item.variant_title !== "Default Title") body.append(make("span", "sfp-cart-variant", item.variant_title));
          const priceRow = make("div", "sfp-cart-line-price");
          priceRow.append(make("strong", "", money(item.final_line_price)));
          if (item.original_line_price > item.final_line_price) priceRow.append(make("s", "", money(item.original_line_price)));
          body.append(priceRow);
          const controls = make("div", "sfp-cart-line-controls");
          const quantity = make("div", "sfp-cart-quantity");
          quantity.setAttribute("aria-label", cartDialog.dataset.quantityLabel);
          const decrease = make("button", "", "−");
          decrease.type = "button";
          decrease.setAttribute("aria-label", cartDialog.dataset.decreaseLabel);
          decrease.addEventListener("click", () => setQuantity(item.key, Math.max(0, item.quantity - 1)));
          const quantityValue = make("span", "", String(item.quantity));
          quantityValue.setAttribute("aria-live", "polite");
          const increase = make("button", "", "+");
          increase.type = "button";
          increase.setAttribute("aria-label", cartDialog.dataset.increaseLabel);
          increase.addEventListener("click", () => setQuantity(item.key, item.quantity + 1));
          quantity.append(decrease, quantityValue, increase);
          const remove = make("button", "sfp-cart-remove", cartDialog.dataset.removeLabel);
          remove.type = "button";
          remove.addEventListener("click", () => setQuantity(item.key, 0));
          controls.append(quantity, remove);
          body.append(controls);
          article.append(body);
          cartItems.append(article);
        });
        cartDialog.querySelector("[data-cart-empty]").hidden = cart.item_count > 0;
        cartDialog.querySelector("[data-cart-footer]").hidden = cart.item_count === 0;
        const cartUpsell = cartDialog.querySelector("[data-cart-upsell]");
        if (cartUpsell) cartUpsell.hidden = cart.item_count === 0;
        cartDialog.querySelector("[data-cart-item-count]").textContent = cart.item_count;
        cartDialog.querySelector("[data-cart-subtotal]").textContent = money(cart.total_price);
        document.querySelectorAll("a.snh-cart-link").forEach(link => {
          let counter = link.querySelector(".snh-cart-count");
          if (!counter) {
            counter = make("span", "snh-cart-count");
            link.append(counter);
          }
          counter.textContent = cart.item_count;
          counter.hidden = cart.item_count === 0;
          if (!link.dataset.cartLabel) link.dataset.cartLabel = (link.getAttribute("aria-label") || "").replace(/\s*\(\d+\)$/u, "");
          link.setAttribute("aria-label", `${link.dataset.cartLabel} (${cart.item_count})`);
        });
      };
      const loadCart = async () => {
        cartLoading.hidden = false;
        cartError.hidden = true;
        cartDialog.setAttribute("aria-busy", "true");
        try { renderCart(await requestCart(`${cartUrl}.js`)); }
        catch (error) { showCartError(error); }
        finally { cartLoading.hidden = true; cartDialog.removeAttribute("aria-busy"); }
      };
      const setQuantity = async (key, quantity) => {
        if (updatingCart) return;
        updatingCart = true;
        cartError.hidden = true;
        cartItems.setAttribute("aria-busy", "true");
        cartItems.querySelectorAll("button").forEach(button => { button.disabled = true; });
        try {
          renderCart(await requestCart(`${cartUrl}/change.js`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity }) }));
          const line = [...cartItems.children].find(item => item.dataset.lineKey === key);
          (line?.querySelector(".sfp-cart-quantity button") || cartDialog.querySelector("[data-cart-close]")).focus();
        } catch (error) { showCartError(error); }
        finally {
          updatingCart = false;
          cartItems.removeAttribute("aria-busy");
          cartItems.querySelectorAll("button").forEach(button => { button.disabled = false; });
        }
      };
      const openCart = async opener => {
        cartOpener = opener || document.activeElement;
        if (!cartDialog.open) cartDialog.showModal();
        await loadCart();
      };
      const addToCart = async (event, submittedForm) => {
        if (!window.fetch) return;
        event.preventDefault();
        if (addingToCart) return;
        const selected = variantInputs.find(input => input.checked);
        if (submittedForm === form && selected?.dataset.available !== "true") return;
        const submitButton = event.submitter || submittedForm.querySelector("button[type=submit]");
        const payload = new FormData(submittedForm);
        addingToCart = true;
        variantInputs.forEach(input => { input.disabled = true; });
        root.querySelectorAll("[data-filtro-buy]").forEach(button => { button.disabled = true; });
        if (submitButton) submitButton.disabled = true;
        try {
          await requestCart(`${cartUrl}/add.js`, { method: "POST", body: payload });
          await openCart(submitButton);
        } catch (error) {
          cartOpener = submitButton;
          if (!cartDialog.open) cartDialog.showModal();
          cartLoading.hidden = true;
          showCartError(error);
        } finally {
          addingToCart = false;
          variantInputs.forEach(input => { input.disabled = false; });
          updateVariant(variantInputs.find(input => input.checked));
          if (submittedForm !== form && submitButton) submitButton.disabled = false;
        }
      };
      form?.addEventListener("submit", event => addToCart(event, form));
      cartDialog.querySelector("[data-cart-upsell-form]")?.addEventListener("submit", event => addToCart(event, event.currentTarget));
      document.querySelectorAll("a.snh-cart-link").forEach(link => link.addEventListener("click", event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        openCart(link);
      }));
      cartDialog.querySelectorAll("[data-cart-close]").forEach(button => button.addEventListener("click", () => cartDialog.close()));
      cartDialog.addEventListener("close", () => cartOpener?.focus());
      cartDialog.addEventListener("click", event => {
        if (event.target !== cartDialog) return;
        const bounds = cartDialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) cartDialog.close();
      });
    }
    const sticky = root.querySelector("[data-filtro-sticky]");
    const buy = form?.querySelector("[data-filtro-buy]");
    const topButton = root.querySelector("[data-filtro-top]");
    if (sticky && buy && "IntersectionObserver" in window) {
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        const shouldShow = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.hidden = !shouldShow;
        if (topButton) topButton.hidden = !shouldShow;
      }, { threshold: 0 });
      observer.observe(buy);
    }
    topButton?.addEventListener("click", () => root.querySelector("#filtro-product")?.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" }));
  };
  document.querySelectorAll("[data-filtro-product]").forEach(initialize);
  document.addEventListener("shopify:section:load", event => event.target.querySelectorAll("[data-filtro-product]").forEach(initialize));
})();
